import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { servicesData } from "../../public/data/ServicesData";
import { Helmet } from "react-helmet-async";
import ReactMarkdown from "react-markdown";

function ServiceDetail() {
	const { serviceId } = useParams();
	const [markdownContent, setMarkdownContent] = useState("");
	const [loading, setLoading] = useState(true);

	// Find the service based on the predefined slug
	const service = servicesData.find((s) => s.slug === serviceId);

	useEffect(() => {
		if (service) {
			// Load the markdown file for this service
			fetch(`/data/${service.slug}.md`)
				.then((response) => {
					if (!response.ok) {
						throw new Error("Markdown file not found");
					}
					return response.text();
				})
				.then((text) => {
					setMarkdownContent(text);
					setLoading(false);
				})
				.catch((error) => {
					console.error("Error loading markdown:", error);
					setMarkdownContent("");
					setLoading(false);
				});
		}
	}, [service]);

	if (!service) {
		return (
			<div className="min-h-screen flex flex-col items-center justify-center p-4">
				<Helmet>
					<title>Service Not Found | Steer Smart Driving School</title>
					<meta name="robots" content="noindex, nofollow" />
				</Helmet>
				<h1 className="text-2xl font-bold mb-4">Service not found</h1>
				<Link to="/services" className="text-steerOrange hover:underline">
					Back to Services
				</Link>
			</div>
		);
	}

	return (
		<div className="flex flex-col gap-4 min-h-screen">
			<Helmet>
				<title>{service.metaTitle}</title>
				<meta name="description" content={service.metaDescription} />
				<link
					rel="canonical"
					href={`https://steersmartdriving.com.au/services/${service.slug}`}
				/>
			</Helmet>

			{/* <img
				src={service.image}
				alt={service.title}
				className="w-full h-96 object-cover rounded-xl"
			/> */}

			<div className="px-0 lg:px-48 py-6 md:py-12">
				{/* <h2 className="text-2xl font-semibold mb-6 text-gray-900 dark:text-white">
          Details:
        </h2>
        <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-8">
          {service.description}
        </p> */}

				{loading ? (
					<div className="flex justify-center items-center py-8">
						<div className="animate-spin rounded-full h-8 w-8 border-b-2 border-steerOrange"></div>
					</div>
				) : markdownContent ? (
					<div className="prose prose-base md:prose-lg max-w-none dark:prose-invert prose-headings:text-gray-900 dark:prose-headings:text-white prose-p:text-gray-700 dark:prose-p:text-gray-300 prose-a:text-steerOrange hover:prose-a:text-steerOrange/80 prose-strong:text-gray-900 dark:prose-strong:text-white">
						<ReactMarkdown>{markdownContent}</ReactMarkdown>
					</div>
				) : (
					<p className="text-gray-500 dark:text-gray-400 italic">
						Additional content for this service is currently being updated.
					</p>
				)}

				<div className="mt-16 pt-8 border-t border-gray-200 dark:border-gray-700">
					<h3 className="text-xl font-bold mb-6 text-gray-900 dark:text-white">
						Explore Other Services
					</h3>
					<div className="flex flex-wrap gap-3">
						{servicesData
							.filter((s) => s.slug !== serviceId)
							.map((s) => (
								<Link
									key={s.slug}
									to={`/services/${s.slug}`}
									className="px-2 py-1 bg-orange-100 text-orange-800 text-sm rounded-full hover:bg-orange-200 transition-colors cursor-pointer inline-block"
								>
									{s.title}
								</Link>
							))}
					</div>
				</div>
			</div>
		</div>
	);
}

export default ServiceDetail;
